export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/character_modeling.055a44e.svg";